import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26fcf5de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { id: "server-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Server = _resolveComponent("Server")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pollingRate) = $event))
    }, null, 512), [
      [_vModelText, _ctx.pollingRate]
    ]),
    _hoisted_2,
    (_ctx.polling)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.stopPolling && _ctx.stopPolling(...args)), ["prevent"]))
        }, "Stop polling"))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startPolling && _ctx.startPolling(...args)), ["prevent"]))
        }, "Start polling")),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateStatus && _ctx.updateStatus(...args)), ["prevent"]))
    }, "Update"),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servers, (server, index) => {
        return (_openBlock(), _createBlock(_component_Server, {
          key: index,
          id: index,
          tests: server.testCases,
          success: server.success,
          lastUpdated: server.lastUpdated
        }, null, 8, ["id", "tests", "success", "lastUpdated"]))
      }), 128))
    ])
  ]))
}